import { DocumentLoader } from './loaders/document-loader';
import { BlockLoader } from './loaders/block-loader';
import { ShortcodeLoader } from './loaders/shortcode-loader';
import { FormService } from './services/form-service';
import { Logger } from './utils/logger';
/**
 * Main entry point for GP Submit to Access frontend functionality
 */
class GPSAMain {
    /**
     * Initialize the plugin
     */
    static initialize() {
        Logger.debug('Initializing GP Submit to Access');
        // Initialize Gravity Forms integration
        FormService.initializeGravityFormsIntegration();
        // Auto-detect and initialize loaders
        this.initializeLoaders();
        Logger.debug('GP Submit to Access initialization complete');
    }
    /**
     * Auto-detect and initialize loaders based on window configuration objects
     */
    static initializeLoaders() {
        let loadersInitialized = 0;
        const nonConfigKeys = ['gpsa_shared'];
        // Iterate through all window properties to find GPSA configurations
        Object.keys(window).forEach((key) => {
            if (key.startsWith('gpsa_') && !nonConfigKeys.includes(key)) {
                try {
                    const config = window[key];
                    Logger.debug(`Processing configuration for key: ${key}`, config);
                    if (this.isValidConfig(config)) {
                        this.initializeLoader(config);
                        loadersInitialized++;
                    }
                    else {
                        Logger.warn(`Invalid configuration found for key: ${key}`, config);
                    }
                }
                catch (error) {
                    Logger.error(`Error processing configuration for key: ${key}`, error);
                }
            }
        });
        Logger.debug(`Initialized ${loadersInitialized} content loaders`);
    }
    /**
     * Validate configuration object
     * @param config
     */
    static isValidConfig(config) {
        return (config &&
            typeof config === 'object' &&
            config.type &&
            typeof config.postId === 'string' &&
            !isNaN(Number(config.postId)) &&
            typeof config.formId === 'string' &&
            !isNaN(Number(config.formId)) &&
            typeof config.contentId === 'string' &&
            config.settings &&
            typeof config.ajaxUrl === 'string' &&
            typeof config.nonce === 'string');
    }
    /**
     * Initialize a specific loader based on its type
     * @param config
     */
    static initializeLoader(config) {
        switch (config.type) {
            case 'document':
                DocumentLoader.createFromConfig(config);
                Logger.debug(`Initialized document loader for post ${config.postId}`);
                break;
            case 'block':
                BlockLoader.createFromConfig(config);
                Logger.debug(`Initialized block loader for content ${config.contentId}`);
                break;
            case 'shortcode':
                ShortcodeLoader.createFromConfig(config);
                Logger.debug(`Initialized shortcode loader for content ${config.contentId}`);
                break;
            default:
                Logger.warn(`Unknown loader type: ${config.type}`);
        }
    }
}
// Initialize when DOM is ready
jQuery(document).ready(() => {
    GPSAMain.initialize();
});
// Export for potential external use
window.GPSAMain = GPSAMain;
